/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*
*/

(() => {
  const footerNewsLetterForm = document.querySelector("#newsLetterFormTemplate");
  const emailField = footerNewsLetterForm?.querySelector("#email"),
    firstNameField = footerNewsLetterForm?.querySelector("#first_name"),
    lastNameField = footerNewsLetterForm?.querySelector("#last_name");
  const submitButton = footerNewsLetterForm?.querySelector("[type=submit]");
  
  const FieldConstants = {
    EMAIL: "7f1a2314-8143-4c90-8a57-1676e08ba8ec",
    FIRST_NAME: "e9d47593-5288-4117-b560-e481bd0b1e79",
    LAST_NAME: "ef1405da-dbd2-4da3-af07-a4f893f4eb2e"
  }

  if(!footerNewsLetterForm)
    return;

  
  const urlParams = new URLSearchParams(window.location.search);
  if(urlParams.get("customer_posted") == "true" // when new user is created on server
     || urlParams.get("form_type") == "customer") {
    window.location.href = "/";
  }
  
  function wait(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }

  window.acerillFormBuilderOnFormSubmitted = async function(submission) {
    emailField.focus();
    
    emailField.value = submission[FieldConstants.EMAIL]?.value;
    firstNameField.value = submission[FieldConstants.FIRST_NAME]?.value;
    lastNameField.value = submission[FieldConstants.LAST_NAME]?.value;

    window.Shopify.captcha.protect(footerNewsLetterForm, () => {
      footerNewsLetterForm.submit();
    });
  };
})();

(function() {
  $('.fancy_shipping-link').on('click', function(e){
    e.preventDefault();
    $.fancybox.open({
      src  : '.popup_shipping',
      type : 'inline',
      opts : {
        afterShow : function( instance, current ) {
          console.info( 'done!' );
        }
      }
    })
  })
  $('.fancy_help-link').on('click', function(e){
    e.preventDefault();
    $.fancybox.open({
      src  : '.popup_help',
      type : 'inline',
      opts : {
        afterShow : function( instance, current ) {
          console.info( 'done!' );
        }
      }
    })
  })
  var triggerVanillaModal = function(el) {
      var element = document.querySelector("#vanilla-modal-wrap");
      element.classList.add('open');
  };


  // add to cart button will be disabled when variant not in stock
  var addToCartBtn = document.querySelector('.ProductForm__AddToCart ');

  // close modal on esc key
  window.addEventListener("keydown", function(event) {
      var keyPressed = event.code;
      if ( keyPressed == 'Escape' ) {
          var els = document.getElementsByClassName("vanilla-modal-wrap");
          els[0].classList.remove("open");
      }
  }, true);

  document.addEventListener('click',function(e){
    if(e.target && (e.target.id == 'vanilla-modal-button' || e.target.id == 'vmb-span')){
      triggerVanillaModal();
      e.preventDefault();
    }
  });

  // close modal on .close-modal click
  var modalCloseButton = document.querySelector("#btn-modal-close");

  modalCloseButton.addEventListener('click', (event) => {
      var els = document.getElementsByClassName("vanilla-modal-wrap");
      els[0].classList.remove("open");
  });

  var modalTriggerButton = document.querySelector("#vanilla-modal-button");

  if ( modalTriggerButton ) {
    modalTriggerButton.addEventListener('click', (event) => {
        triggerVanillaModal();
        event.preventDefault();
    });
  }
  
  var modalTriggerButtonSpan = document.querySelector("#vmb-span");

  if ( modalTriggerButtonSpan ) {
    modalTriggerButtonSpan.addEventListener('click', (event) => {
        triggerVanillaModal();
        event.preventDefault();
    });
  }
  
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    
    var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);

    var productData = jsonData['product'];
    var variantsInventories = jsonData['inventories'] || {};
    
    var selectedVariant = variantsInventories[variant.id];
    var qty = selectedVariant["inventory_quantity"];
    
    console.log(variant.id+'QTY:'+ qty);
    
      var variantIsAvailable = variant.available;
      var stockMessageWrap   = document.querySelector("#info-wrap");
    
    if(stockMessageWrap != null)
      var shippingTime       = stockMessageWrap.getAttribute('data-shipping');
    
    if ( shippingTime == '' ) {
     shippingTime = 'DEFAULT'; 
    }
    
      var stockButton        = '<button id="vanilla-modal-button" class="btn-modal">Ready to ship. &nbsp;Please allow 1 - 3 days to ship. &nbsp;<span id="vmb-span">If purchasing additional items please see here.</span></button>';
      var customOrderText    = '<p>Made to order.&nbsp; Please allow ' + shippingTime + ' to ship.</p>';
      var noStockText        = '';
      var message            = '';

      if (variantIsAvailable) {
        if ( qty > 0 ) {
          message = stockButton;
        } else {
          message = customOrderText;
        }
      } else {
          message = noStockText;
      }
      stockMessageWrap.innerHTML = message;
  });

      
  var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var productData = jsonData['product'];
  var variantsInventories = jsonData['inventories'] || {};
  var variantId = jsonData["selected_variant_id"];
  var selectedVariant = variantsInventories[variantId];
  var qty = selectedVariant["inventory_quantity"];

  console.log(variantId + 'Q' + qty);

  var addToCartDisabled  = addToCartBtn.disabled;
  var stockMessageWrap   = document.querySelector("#info-wrap");
  var shippingTime       = stockMessageWrap.getAttribute('data-shipping');
  
   if ( shippingTime == '' ) {
     shippingTime = 'DEFAULT'; 
    }
  
  var stockButton        = '<button id="vanilla-modal-button" class="btn-modal">Ready to ship. &nbsp;Please allow 1 - 3 days to ship. &nbsp;<span id="vmb-span">If purchasing additional items please see here.</span></button>';
  var customOrderText    = '<p>Made to order.&nbsp; Please allow ' + shippingTime + ' to ship.</p>';
  var noStockText        = '';
  var message            = '';
  if (stockMessageWrap) {
    console.log(addToCartDisabled);

    if (addToCartDisabled) {
      message = noStockText;
    } else {
      if ( qty > 0 ) {
      	message = stockButton;
      } else {
       	message = customOrderText;
      }
    }
    
    stockMessageWrap.innerHTML = message;

  }
})();
